export const types = {
  UPDATE_ACCOUNT_LIST: 'UPDATE_ACCOUNT_LIST',
};
